import Vue from "vue";
import Vuex from "vuex";

//import VuexPersistence from 'vuex-persist';
//import localForage from 'localforage';

import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";

import auth from './modules/auth'
import personel from './modules/personel'
import permission from './modules/permission'
import functionality from "./modules/functionality";
import periodFunctionality from "./modules/periodFunctionality";
import monthlyFunctionality from "./modules/monthlyFunctionality";
import message from "./modules/message";
import settings from "./modules/settings";
import ioInfo from "./modules/ioInfo";
import vacation from "./modules/vacation";
import mission from "./modules/mission";
import extrawork from "./modules/extrawork";
import request from "./modules/general";
import sections from "./modules/sections";
import pattern from "./modules/pattern";
import config from "./modules/config";
import notification from "./modules/notification";
import lock from "./modules/lock";
import geolocation from "./modules/geolocation";

/*const vuexLocal = new VuexPersistence({
  storage: localForage,
  asyncStorage: true,
});*/


Vue.use(Vuex);

const store = new Vuex.Store({
  //plugins: [vuexLocal.plugin],
  plugins: [
    createPersistedState(
      {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 7 }),
        removeItem: key => Cookies.remove(key)
      })
  ],

  modules: {
    auth,
    personel,
    permission,
    functionality,
    periodFunctionality,
    monthlyFunctionality,
    message,
    settings,
    ioInfo,
    vacation,
    mission,
    extrawork,
    request,
    sections,
    pattern,
    config,
    notification,
    lock,
    geolocation,
  }
});

/*store.subscribe((mutation, state) => {
  console.log('store.subscribe:', JSON.stringify(state));
  /*let store = {
    version: state.version,
    count: 1
  };

  localStorage.setItem('store', JSON.stringify(state));
});*/

export default store;
